/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import {
  accessAPI,
  formatFecha,
  Titulo,
  CampoInformacion,
  Sidebar,
  TablaFiltrable
} from "../../shared";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Skeleton } from "primereact/skeleton";
import { Divider } from "primereact/divider";
import DatosContacto from "../importaciones/DatosContacto";

const TAG_CLASIFICACION = {
  CONTROL: { value: "Control", severity: "danger" },
  CROSS_SELL: { value: "Cross-sell", severity: "success" },
  PROSPECCION: { value: "Prospección", severity: "info" }
};

const FILTROS = [
  { campo: "_clienteText", label: "Cliente", labelPlural: "clientes" },
  { campo: "_tipoProducto", label: "Tipo de producto", labelPlural: "tipos de producto" },
  { campo: "_clasificacionText", label: "Clasificación", labelPlural: "clasificaciones" }
];
const SEARCH_FIELDS = ["_clienteText", "razonSocialImportador", "rutImportador"];

// Contenido del tab "Importaciones" del acordeón de Gestión. No es una página:
// el Toast lo pone Gestion.js, acá solo se usa.
export default function ImportacionesRevision({ toast }) {
  const [importaciones, setImportaciones] = useState(null);
  const [seleccionada, setSeleccionada] = useState(null);

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/importacion/revision",
      null,
      (respuesta) => setImportaciones(respuesta),
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar importaciones",
          sticky: true
        });
        setImportaciones([]);
      }
    );
  }, [toast]);

  // Cliente de Morfeo cuando el matching confirmó uno; para las prospecciones
  // (sin cliente) se cae al nombre crudo de Penta, que es el único que existe.
  // El dato crudo completo sigue en el sidebar de detalle.
  const datos = (importaciones || []).map((i) => ({
    ...i,
    _clienteText: i.cliente?.razonsocial || i.razonSocialImportador,
    _tipoProducto: i.certificadotipo?.nombre || "-",
    _clasificacionText: TAG_CLASIFICACION[i.clasificacion]?.value || i.clasificacion
  }));

  return (
    <>
      {!importaciones && <Skeleton width="100%" height="10rem" borderRadius="6px" />}

      {importaciones && (
        <TablaFiltrable
          value={datos}
          filtros={FILTROS}
          searchFields={SEARCH_FIELDS}
          busquedaAlFinal
          anchoBusqueda="33%"
          nombreArchivo="importaciones"
          size="small"
          emptyMessage="No hay importaciones para revisar"
          onRowClick={(e) => setSeleccionada(e.data)}
          rowClassName={() => "cursor-pointer"}
        >
          <Column field="_clienteText" header="Cliente" />
          <Column field="_tipoProducto" header="Tipo de producto" />
          <Column
            field="ncm"
            header="NCM"
            style={{ width: "8em" }}
            alignHeader="center"
            bodyStyle={{ textAlign: "center" }}
          />
          <Column
            header="Cantidad"
            body={(i) => i.cantidad || "-"}
            style={{ width: "10em" }}
            alignHeader="center"
            bodyStyle={{ textAlign: "center" }}
          />
          <Column
            header="Fecha de importación"
            body={(i) => formatFecha(i.fechaImportacion)}
            style={{ width: "12em" }}
            alignHeader="center"
            bodyStyle={{ textAlign: "center" }}
          />
          <Column
            body={(i) => {
              const tag = TAG_CLASIFICACION[i.clasificacion];
              return tag ? <Tag value={tag.value} severity={tag.severity} /> : i.clasificacion;
            }}
            style={{ width: "10em" }}
          />
        </TablaFiltrable>
      )}

      <Sidebar
        visible={!!seleccionada}
        onHide={() => setSeleccionada(null)}
        position="right"
        closeIcon={
          <div>
            <i className="pi pi-times"></i>
          </div>
        }
        className="w-full lg:w-30rem md:w-30rem"
      >
        {seleccionada && (
          <div css={{ marginBottom: "50px" }}>
            <Titulo>{seleccionada.razonSocialImportador}</Titulo>
            <div className="grid">
              <CampoInformacion nombreCampo="RUT">
                {seleccionada.rutImportador || "-"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Teléfono">
                {seleccionada.telefono || "-"}
              </CampoInformacion>
            </div>
            <div className="grid">
              <CampoInformacion nombreCampo="Dirección" anchoCompleto>
                {seleccionada.direccion || "-"}
              </CampoInformacion>
            </div>
            <Divider />
            <div className="grid">
              <CampoInformacion nombreCampo="NCM">{seleccionada.ncm}</CampoInformacion>
              <CampoInformacion nombreCampo="Tipo de producto">
                {seleccionada.certificadotipo?.nombre || "-"}
              </CampoInformacion>
            </div>
            <CampoInformacion nombreCampo="Fecha de importación">
              {formatFecha(seleccionada.fechaImportacion)}
            </CampoInformacion>
            {seleccionada.cliente && (
              <CampoInformacion nombreCampo="Cliente en Morfeo">
                {seleccionada.cliente.razonsocial}
              </CampoInformacion>
            )}
            <DatosContacto datosContacto={seleccionada.datosContacto} />
          </div>
        )}
      </Sidebar>
    </>
  );
}
